// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-22f04279]{max-height:4rem;max-width:100%}.nav-button[data-v-22f04279]{margin-left:8px}.nav-button[data-v-22f04279]:first-child{margin-left:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
